/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_UploadingInputs */

const id_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengunggah...`)
};

const ms_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat naik...`)
};

const da_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploader...`)
};

const de_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochladen...`)
};

const en_us2_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading...`)
};

const es_es2_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiendo...`)
};

const es_mx2_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiendo...`)
};

const fil_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nag-u-upload...`)
};

const fr_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversement…`)
};

const it_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const hu_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feltöltés...`)
};

const nl_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met uploaden...`)
};

const no_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster opp...`)
};

const pl_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przesyłanie...`)
};

const pt_br2_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazendo upload...`)
};

const pt_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar...`)
};

const ro_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se încarcă...`)
};

const fi_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar upp...`)
};

const vi_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải lên...`)
};

const tr_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const cs_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrávání...`)
};

const bg_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Качване...`)
};

const ru_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const hi_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपलोड हो रहा है...`)
};

const th_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังอัปโหลด...`)
};

const ja_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロード中...`)
};

const zh_cn2_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上传...`)
};

const zh_hant1_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上傳...`)
};

const ko_profile_avatar_uploading = /** @type {(inputs: Profile_Avatar_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업로드 중...`)
};

/**
* | output |
* | --- |
* | "Uploading..." |
*
* @param {Profile_Avatar_UploadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_uploading = /** @type {((inputs?: Profile_Avatar_UploadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_UploadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_uploading(inputs)
	if (locale === "ms") return ms_profile_avatar_uploading(inputs)
	if (locale === "da") return da_profile_avatar_uploading(inputs)
	if (locale === "de") return de_profile_avatar_uploading(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_uploading(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_uploading(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_uploading(inputs)
	if (locale === "fil") return fil_profile_avatar_uploading(inputs)
	if (locale === "fr") return fr_profile_avatar_uploading(inputs)
	if (locale === "it") return it_profile_avatar_uploading(inputs)
	if (locale === "hu") return hu_profile_avatar_uploading(inputs)
	if (locale === "nl") return nl_profile_avatar_uploading(inputs)
	if (locale === "no") return no_profile_avatar_uploading(inputs)
	if (locale === "pl") return pl_profile_avatar_uploading(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_uploading(inputs)
	if (locale === "pt") return pt_profile_avatar_uploading(inputs)
	if (locale === "ro") return ro_profile_avatar_uploading(inputs)
	if (locale === "fi") return fi_profile_avatar_uploading(inputs)
	if (locale === "sv") return sv_profile_avatar_uploading(inputs)
	if (locale === "vi") return vi_profile_avatar_uploading(inputs)
	if (locale === "tr") return tr_profile_avatar_uploading(inputs)
	if (locale === "cs") return cs_profile_avatar_uploading(inputs)
	if (locale === "bg") return bg_profile_avatar_uploading(inputs)
	if (locale === "ru") return ru_profile_avatar_uploading(inputs)
	if (locale === "uk") return uk_profile_avatar_uploading(inputs)
	if (locale === "ar") return ar_profile_avatar_uploading(inputs)
	if (locale === "hi") return hi_profile_avatar_uploading(inputs)
	if (locale === "th") return th_profile_avatar_uploading(inputs)
	if (locale === "ja") return ja_profile_avatar_uploading(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_uploading(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_uploading(inputs)
	return ko_profile_avatar_uploading(inputs)
});
export { profile_avatar_uploading as "profile.avatar.uploading" }